/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateKnownIssueDto interface.
 */
export function instanceOfCreateKnownIssueDto(value) {
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('content' in value) || value['content'] === undefined)
        return false;
    return true;
}
export function CreateKnownIssueDtoFromJSON(json) {
    return CreateKnownIssueDtoFromJSONTyped(json, false);
}
export function CreateKnownIssueDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'],
        'content': json['content'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}
export function CreateKnownIssueDtoToJSON(json) {
    return CreateKnownIssueDtoToJSONTyped(json, false);
}
export function CreateKnownIssueDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'content': value['content'],
        'displayOrder': value['displayOrder'],
        'active': value['active'],
    };
}
